module.exports = __webpack_public_path__ + "img/step-01.6ee384a0.png";